// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"726":"32cab953","769":"ffe16d1f"}[chunkId] + ".css";
};